import React from "react";
import data from "../../json/index.json";
import Product from "./Product";

const ProductsGrid = ({ is3x3, isHome }) => {
  return (
    <div className="productsGrid animate__animated animate__fadeIn">
      <div className="product-main container">
        {isHome ? (
          <h1 className="dc-script text-center">New organic products</h1>
        ) : (
          <></>
        )}
        <div
          className={
            is3x3 ? "products-grid-3 dm-sans " : "products-grid-4 dm-sans"
          }
        >
          {data.products.map((item) => (
            <Product isBorder={false} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsGrid;
